import type { StaticField } from '../../Views/types'
import type { QuickLinksSource } from '../types'
import { QuickLinksCardItem } from './QuickLinksCardItem'

interface Props {
  sources: QuickLinksSource[]
  fields: StaticField[]
  activeFieldId?: string
  preview: boolean
}
export const QuickLinksCard = ({
  sources,
  fields,
  activeFieldId,
  preview,
}: Props) => {
  return (
    <div className="space-y-5">
      {sources.map(source => (
        <QuickLinksCardItem
          key={source.id}
          source={source}
          fields={fields.filter(
            field =>
              field.enabled &&
              !(field.styles && field.styles.indexOf('card') === -1),
          )}
          activeFieldId={activeFieldId}
          preview={preview}
        />
      ))}
    </div>
  )
}
